import React, { Component } from 'react';
import BarChart from './BarChart';

const ServiceChart = ({labels, datasets, colors}) => (
  <>
    <h3>Hours Per Service</h3>
    <div className="space-12" />
    <BarChart
      {...{
        labels,
        datasets,
        colors,
        swapRowsColumns: true,
        horizontalColors: true,
        horizontalTotal: datasets.length > 1,
        verticalTotal: true,
        units: 'hrs'
      }}
    />
  </>
);

export default ServiceChart;
